import React from "react";


const MontantView = () => {

    return <h2>Montant Page</h2>
}

export default MontantView;